var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "categories-filter" }, [
    !_vm.collapsed
      ? _c(
          "div",
          { staticClass: "checkbox-container" },
          _vm._l(_vm.currentCategories, function(categories) {
            return _c(
              "div",
              {
                key: categories.title,
                staticClass: "checkbox-button gap-05vw"
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedCategories,
                      expression: "selectedCategories"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    value: categories.title,
                    checked: _vm.selectedCategories.includes(categories.title),
                    checked: Array.isArray(_vm.selectedCategories)
                      ? _vm._i(_vm.selectedCategories, categories.title) > -1
                      : _vm.selectedCategories
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.selectedCategories,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = categories.title,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.selectedCategories = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.selectedCategories = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.selectedCategories = $$c
                        }
                      },
                      function($event) {
                        return _vm.setSelectedCategories(categories.title)
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c("p", { class: categories.title == "Sale" ? "red" : "" }, [
                  _vm._v(_vm._s(categories.title))
                ])
              ]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }